import { Button } from "./Button";
import { formatMessage, t } from "../../lib/i18n";

interface PaginationProps {
  total: number;
  limit: number;
  offset: number;
  onChange: (next: { limit: number; offset: number }) => void;
  pageSizes?: number[];
}

export function Pagination({
  total,
  limit,
  offset,
  onChange,
  pageSizes = [25, 50, 100, 200],
}: PaginationProps) {
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(total, offset + limit);
  const canPrev = offset > 0;
  const canNext = offset + limit < total;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "12px 16px",
        gap: 12,
        borderTop: "1px solid var(--color-border)",
        background: "var(--color-surface-2)",
        fontFamily: "var(--font-mono)",
        fontSize: 12,
        color: "var(--color-text-muted)",
      }}
    >
      <span>
        {formatMessage("common.pagination.showing", {
          from: String(from),
          to: String(to),
          total: String(total),
        })}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <label
          style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12 }}
        >
          {t("common.pagination.perPage")}
          <select
            className="select"
            value={limit}
            onChange={(e) => {
              const next = Number(e.target.value) || 25;
              onChange({ limit: next, offset: 0 });
            }}
            style={{ height: 28, padding: "0 22px 0 8px", minWidth: 56 }}
          >
            {pageSizes.map((size) => (
              <option key={size} value={size}>
                {size}
              </option>
            ))}
          </select>
        </label>
        <Button
          variant="secondary"
          size="sm"
          disabled={!canPrev}
          onClick={() => onChange({ limit, offset: Math.max(0, offset - limit) })}
        >
          {t("common.prev")}
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={!canNext}
          onClick={() => onChange({ limit, offset: offset + limit })}
        >
          {t("common.next")}
        </Button>
      </div>
    </div>
  );
}
